import { WidgetBase } from '../models';
import { Helper } from '../../common';

import { alarmsDisabledTableWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class AlarmsDisabledTableWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration = {};
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 12;
    sizeY = 6;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
    }
}